class ToggleState {

	constructor(elemTrigger, a, b){
		this.trigger = document.querySelectorAll(`[data-trigger="${elemTrigger}"]`);
		this.target  = document.querySelector(`[data-target="${elemTrigger}"]`);
		this.stateA  = a;
		this.stateB  = b;
		this._init();
	}

	_init(){
		for (let element of this.trigger) {
			element.addEventListener('click', ()=> this.toggleState(this.stateA, this.stateB) );
		}
	}
		
	toggleState(one, two) {
		const newState = this.target.getAttribute('data-state') === one ? two : one;
  	this.target.setAttribute('data-state', newState);
	}

}

export default ToggleState;